import { connect } from 'react-redux';
import History from './History';
import { cancelAndRemoveFromReservations, getInitialMonths, getPreviousMonth } from '../../actions/history';
import { triggerCloseCancelReservationScreen } from '../../actions/cancelling';

const mapStateToProps = state => ({
  historyInitialLoading: state.history.historyInitialLoading,
  historyInitialLoaded: state.history.historyInitialLoaded,
  historyLoading: state.history.historyLoading,
  historyLoaded: state.history.historyLoaded,
  reservations: state.history.reservations,
  resources: state.resources,
  units: state.units,
  numberOfResults: state.history.numberOfResults,
  cancellingReservationError: state.cancelling.cancellingReservationError,
  reservationCancelled: state.cancelling.reservationCancelled
});
const mapDispatchToProps = dispatch => ({
  cancelAndRemoveFromReservations: dispatch(cancelAndRemoveFromReservations),
  getInitialMonths: dispatch(getInitialMonths),
  getPreviousMonth: dispatch(getPreviousMonth),
  closeCancelReservationScreen: dispatch(triggerCloseCancelReservationScreen)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(History);



// WEBPACK FOOTER //
// ./src/containers/History/index.js